// ✅ main.tsx — modifié pour inclure UserProvider
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { supabase } from "./lib/supabase";
import App from "./pages/App";
import Login from "./pages/Login";
import "./index.css";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { UserProvider } from "./lib/UserContext";
import { StaffProvider } from "./lib/StaffContext";
import { PatientDirectoryProvider } from "./lib/PatientDirectoryContext";
import { Toaster } from "react-hot-toast";
import ConfirmBooking from "./components/ConfirmBooking";
import ManageBooking from "./components/ManageBooking";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <UserProvider>
      <StaffProvider>
      <PatientDirectoryProvider>
        <BrowserRouter>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/confirm-booking/:token" element={<ConfirmBooking />} />
            <Route path="/manage-booking/:token" element={<ManageBooking />} />
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </PatientDirectoryProvider>
      </StaffProvider>
    </UserProvider>
  </React.StrictMode>
);

// ────────────────────────────────────────────────────────────
// Enregistrement du Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Vite émet /service-worker.js à la racine du domaine (scope “/”)
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.error("[SW] register error:", err));
  });
}
// ────────────────────────────────────────────────────────────
